import {
  Button,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { AreasType } from "../../../../../domain/models/executive-summary/force-field-type";
import { useState } from "react";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import HqWiseFieldForce from "./HqWiseFieldForce";

type Props = {
  data: AreasType;
  opened: boolean[];
  index: number;
  setOpened: Function;
  channelPay: boolean;
  channelPaisa: boolean;
};

const FieldForceTableDetail: React.FC<Props> = ({
  data,
  opened,
  setOpened,
  channelPaisa,
  channelPay,
  index,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const openRow = () => {
    let newArray = [...opened];
    if (open === true) {
      newArray[index] = false;
    } else {
      newArray[index] = true;
    }
    setOpen(!open);
    setOpened(newArray);
  };

  const stockistData = data.customers.find(
    (customer) => customer.customer_type_id === 1
  );
  const semiData = data.customers.find(
    (customer) => customer.customer_type_id === 2
  );
  const retailerData = data.customers.find(
    (customer) => customer.customer_type_id === 3
  );
  const ccData = data.customers.find(
    (customer) => customer.customer_type_id === 4
  );
  const hcpData = data.customers.find(
    (customer) => customer.customer_type_id === 5
  );

  const cellStyle = {
    fontSize: "0.8rem", // Decreased font size
  };

  return (
    <>
      <TableRow>
        <TableCell padding="none" align="center" sx={cellStyle}>
          <IconButton onClick={openRow}>
            {open ? (
              <ArrowCircleUpIcon fontSize="small" />
            ) : (
              <ArrowCircleDownIcon fontSize="small" />
            )}
          </IconButton>
        </TableCell>
        <TableCell padding="none" color="#5E5ADB" sx={cellStyle}>
          {data.area_name}
        </TableCell>
        {opened.find((a) => a === true) && (
          <TableCell padding="none" sx={cellStyle} />
        )}
        <TableCell padding="none" align="center" sx={cellStyle}>
          {data.work_day}
        </TableCell>
        <TableCell padding="none" align="center" sx={cellStyle}>
          {data.coverage}
        </TableCell>
        <TableCell padding="none" align="center" sx={cellStyle}>
          {data.call_avg}
        </TableCell>
        <TableCell padding="none" align="center" sx={cellStyle}>
          <Button
            size="small"
            sx={{
              border: "0.5px solid #E1E3E5",
              borderRadius: "7px",
              bgcolor: "white",
              py: "0",
              color: "#464F60",
            }}
          >
            TOUR PLAN
          </Button>
        </TableCell>
        <TableCell padding="none" align="center" sx={cellStyle}>
          {data.DEV}
        </TableCell>
        <TableCell padding="none" align="center" sx={cellStyle}>
          {data.abm_visits}
        </TableCell>
        <TableCell padding="none" align="center" sx={cellStyle}>
          {data.rbm_visits}
        </TableCell>
        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#f5faff" }}
        >
          <Stack>
            <Typography fontSize={11}>{stockistData?.met}</Typography>
            <Typography fontSize={10} color={"gray"}>
              /{stockistData?.total_met}
            </Typography>
          </Stack>
        </TableCell>
        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#f5faff" }}
        >
          {stockistData?.call_avg}
        </TableCell>

        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#f5faff" }}
        >
          {stockistData?.coverage}
        </TableCell>
        {channelPaisa ? (
          <>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#FCFAF7" }}
            >
              <Typography fontSize={11}>₹{semiData?.invoices}</Typography>
              <Typography fontSize={10} color={"gray"}>
                {semiData?.invoices_count} INVOICES
              </Typography>
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#FCFAF7" }}
            >
              <Typography fontSize={11}>₹{semiData?.order}</Typography>
              <Typography fontSize={10} color={"gray"}>
                {semiData?.order_count} ORDERS
              </Typography>
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#FCFAF7" }}
            >
              <Stack direction={"row"} justifyContent={"center"}>
                <Typography color={"green"} fontSize={11} fontWeight={500}>
                  {semiData?.active}
                </Typography>
                <Typography fontSize={11}>/{semiData?.total}</Typography>
              </Stack>
            </TableCell>
          </>
        ) : (
          <>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#FCFAF7" }}
            >
              <Stack>
                <Typography fontSize={11}>{semiData?.met}</Typography>
                <Typography fontSize={10} color={"gray"}>
                  /{semiData?.total_met}
                </Typography>
              </Stack>
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#FCFAF7" }}
            >
              {semiData?.call_avg}
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#FCFAF7" }}
            >
              {semiData?.coverage}
            </TableCell>
          </>
        )}
        {channelPay ? (
          <>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#F8F7FC" }}
            >
              <Typography fontSize={11}>₹{retailerData?.invoices}</Typography>
              <Typography fontSize={10} color={"gray"}>
                {retailerData?.invoices_count} INVOICES
              </Typography>
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#F8F7FC" }}
            >
              <Typography fontSize={11}>₹{retailerData?.order}</Typography>
              <Typography fontSize={10} color={"gray"}>
                {retailerData?.order_count} ORDERS
              </Typography>
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#F8F7FC" }}
            >
              <Stack direction={"row"} justifyContent={"center"}>
                <Typography color={"green"} fontSize={11} fontWeight={500}>
                  {retailerData?.active}
                </Typography>
                <Typography fontSize={11}>/{retailerData?.total}</Typography>
              </Stack>
            </TableCell>
          </>
        ) : (
          <>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#F8F7FC" }}
            >
              <Stack>
                <Typography fontSize={11}>{retailerData?.met}</Typography>
                <Typography fontSize={10} color={"gray"}>
                  /{retailerData?.total_met}
                </Typography>
              </Stack>
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#F8F7FC" }}
            >
              {retailerData?.call_avg}
            </TableCell>
            <TableCell
              padding="none"
              align="center"
              sx={{ ...cellStyle, bgcolor: "#F8F7FC" }}
            >
              {retailerData?.coverage}
            </TableCell>
          </>
        )}
        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#fafdff" }}
        >
          <Stack>
            <Typography fontSize={11}>{ccData?.met}</Typography>
            <Typography fontSize={10} color={"gray"}>
              /{ccData?.total_met}
            </Typography>
          </Stack>
        </TableCell>
        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#fafdff" }}
        >
          {ccData?.call_avg}
        </TableCell>
        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#fafdff" }}
        >
          {ccData?.coverage}
        </TableCell>
        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#f5faff" }}
        >
          <Stack>
            <Typography fontSize={11}>{hcpData?.met}</Typography>
            <Typography fontSize={10} color={"gray"}>
              /{hcpData?.total_met}
            </Typography>
          </Stack>
        </TableCell>
        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#f5faff" }}
        >
          {hcpData?.call_avg}
        </TableCell>
        <TableCell
          padding="none"
          align="center"
          sx={{ ...cellStyle, bgcolor: "#f5faff" }}
        >
          {hcpData?.coverage}
        </TableCell>
      </TableRow>
      {data.headquarters.map((row) => (
        <HqWiseFieldForce
          data={row}
          open={open}
          channelPaisa={channelPaisa}
          channelPay={channelPay}
          areaName={data.area_name}
        />
      ))}
    </>
  );
};

export default FieldForceTableDetail;
